import { TrackJS } from 'trackjs';

import { init as initTrackJS } from './init-trackjs';

const ErrorHandler = {
  configure,
  track,
  addMetadata,
};

/**
 * Configure ErrorHandler
 */
function configure() {
  initTrackJS(TrackJS);
}

/**
 * Track error
 * @param    {Error}    [error]        Error
 */
function track(error) {
  TrackJS.isInstalled() && TrackJS.track(error);

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

/**
 * Add meta data
 * @param    {String}    [name]       Name
 * @param    {String}    [value]      Value
 */
function addMetadata(name, value) {
  TrackJS.addMetadata(name, value);
}

export default ErrorHandler;
